import { Select } from '@mantine/core';
import { FC } from 'react';

import * as Filters from '../../data-access/types/filters';

import { useColFilter } from '@data-access';

type SelectFilterProps = Filters.SelectFilter & {
  name: string;
};

export const SelectFilter: FC<SelectFilterProps> = ({
  name,
  values,
  label,
}) => {
  const [value, setFilter] = useColFilter('orders', name);

  return (
    <Select
      comboboxProps={{ withinPortal: false }}
      data={values?.map((v) => ({ value: v.id.toString(), label: v.name }))}
      label={label}
      onChange={(v) => setFilter(v)}
      value={(value as string | null | undefined) || null}
    />
  );
};
